var liqpay = function(op) {
  this.op = op;
  return this;
};

liqpay.prototype.charge = function() {
  //TODO:
};

var api = function(method, data, callback) {
  //TODO:
};

module.exports = liqpay;
